import { makeStyles } from '@material-ui/core';

export const useAppLayoutStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    borderBottom: `1px solid ${theme.palette.divider}`,
    zIndex: theme.zIndex.appBar,
    boxShadow: theme.shadows[1],
    backdropFilter: 'blur(8px)',
    transition: theme.transitions.create(['box-shadow', 'background-color'], {
      duration: theme.transitions.duration.short,
    }),
  },
  toolbar: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    minHeight: 72,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      minHeight: 64,
    },
  },
  titleContainer: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  title: {
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: '1.5rem',
    lineHeight: 1.2,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.5),
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.25rem',
    },
  },
  subtitle: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    lineHeight: 1.43,
    fontWeight: theme.typography.fontWeightRegular,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8rem',
    },
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(1),
    },
  },
  iconButton: {
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
    transition: theme.transitions.create(['background-color', 'transform', 'box-shadow'], {
      duration: theme.transitions.duration.shorter,
    }),
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      transform: 'scale(1.05)',
      boxShadow: theme.shadows[2],
    },
    '&:active': {
      transform: 'scale(0.98)',
    },
  },
  /**
   * The stack of panels. Page background, width and outer padding now come from `.ovp-page` /
   * `.ovp-page__wrap` in `page-shell.scss`, which owns them for both views — this holds only the gap
   * between the selector above and the first panel.
   *
   * No `min-height` here any more. It was `calc(100vh - 96px)` on top of the wrapper's own `100vh`, so a
   * short page scrolled by roughly a viewport with nothing in the overflow.
   */
  mainContent: {
    paddingTop: theme.spacing(2),
    position: 'relative',
  },
  topSection: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    animation: '$fadeInUp 600ms ease-out',
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(1)
    },
  },
  cardContainer: {
    height: '100%',
  },
  timelineSection: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    animation: '$fadeInUp 800ms ease-out',
    animationDelay: '200ms',
    animationFillMode: 'both',
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(3),
    },
  },
  sectionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(3),
    },
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 200,
    animation: '$pulse 1.5s ease-in-out infinite',
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 200,
    padding: theme.spacing(3),
    textAlign: 'center',
    animation: '$shake 0.5s ease-in-out',
  },
  '@keyframes fadeInUp': {
    '0%': {
      opacity: 0,
      transform: 'translateY(30px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
  '@keyframes pulse': {
    '0%, 100%': {
      opacity: 1,
    },
    '50%': {
      opacity: 0.5,
    },
  },
  '@keyframes shake': {
    '0%, 100%': {
      transform: 'translateX(0)',
    },
    '10%, 30%, 50%, 70%, 90%': {
      transform: 'translateX(-5px)',
    },
    '20%, 40%, 60%, 80%': {
      transform: 'translateX(5px)',
    },
  },
  '@keyframes slideInFromLeft': {
    '0%': {
      opacity: 0,
      transform: 'translateX(-50px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateX(0)',
    },
  },
  '@keyframes slideInFromRight': {
    '0%': {
      opacity: 0,
      transform: 'translateX(50px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateX(0)',
    },
  },
}));
